import { render } from "./Cliente.vue?vue&type=template&id=6c8684fb&scoped=true"
import script from "./Cliente.vue?vue&type=script&lang=js"
export * from "./Cliente.vue?vue&type=script&lang=js"

import "./Cliente.vue?vue&type=style&index=0&id=6c8684fb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8684fb"]])

export default __exports__